var render = function render(){var _vm=this,_c=_vm._self._c;return _c('diffInput',{attrs:{"loading":_vm.load,"type":"select","title":_vm.title ? _vm.title : '',"optList":_vm.List,"placeholder":_vm.placeholder,"lightDark":_vm.lightDark,"hideContainer":_vm.hideContainer},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }